export default __webpack_public_path__ + "static/media/select-clear.eac0e871.png";